/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import MultipleAssetsButtons from '../MultipleAssetsButtons'
import { filterOptions, sortOptions } from './handlers'
import FilterAndSortBarWithActions from '@/components/listings/FilterAndSortBarWithActions'
import { Flex } from '@chakra-ui/react'
import { useResponsive } from '@/hooks/useResponsive'
import { applyFilterParams } from '@/utils/url'
import DefaultFilterByListed from '@/components/listings/DefaultFilterByListed'

const ActionBar = ({ searchParams, onFilterResults, onReset }) => {
  const { flexGap } = useResponsive()
  const flexReverseDirection = {
    base: 'column-reverse',
    lg: 'row'
  }
  const { showBy: defaultShowBy } = searchParams
  const onChangeShowBy = (showBy) => {
    const currentShowBy = showBy || defaultShowBy
    const showObj = currentShowBy
      ? { showBy: currentShowBy }
      : {}

    applyFilterParams(showObj, onFilterResults)
  }

  return (
    <Flex
      justifyContent="space-between"
      flexDirection={flexReverseDirection}
      gap={flexGap}
    >
      <Flex
        gap={flexGap}
      >
        <DefaultFilterByListed
          onChange={onChangeShowBy}
          defaultValue={defaultShowBy}
        />
        <FilterAndSortBarWithActions
          currentValues={searchParams}
          filterOptions={filterOptions}
          onFilterResults={onFilterResults}
          searchResultsKeyData="data"
          searchResultsKeyLabel="name"
          searchResultsKeyValue="name"
          sortOptions={sortOptions}
          onReset={onReset}
        />
      </Flex>
      <MultipleAssetsButtons />
    </Flex>
  )
}

export default ActionBar
